$(function(){

  var optionList = $('.wpcf7-form [name=c1-select]').children();
  var options = [];
  for (var i = 0; i < optionList.length; i++) {
    options.push(optionList.eq(i).text());
  }

  var select = $('.wpcf7-form [name=c1-select]');
  var param = parseInt(location.search.substring(1).replace(/sl_*/,''));
  for (var t = 1; t < options.length; t++) {
    if (param === t) {
      select.val(options[t]);
      $('.customSelectInner').text(options[t]);
    }
  }

});
